<script>
export default {
  name: 'CancelFinalizeDocument',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="355"
  >
    <v-card>
      <v-card-text
        class="text-xs-center"
      >
        <p>{{ $t('message__cancel_finalize') }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click="$emit('close-modal')">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          color="success"
          @click="$emit('cancel-finalize')">{{ $t('buttons__ok') }}</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
